<template>
  <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span
          v-if="!item"
          class="small text-warning"
          style="font-size: 10px"
          v-b-tooltip.hover
          title="Campo vazio!"
          ><i class="fas fa-exclamation"></i
        ></span>
        <b-link
          v-if="ajuda"
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="info"
          v-b-popover.hover.top="ajuda"
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
        <span v-if="required" class="text-danger">*</span>
      </label>
      <v-select
        :options="array"
        :required="required"
        :disabled="disabled || false"
        label="value"
        :reduce="(item) => item.id"
        v-model="item"
        :loading="isLoading"
        v-on:input="item, $emit('input', item), $emit('change')"
        :placeholder="placeholder ? placeholder : `Digite um ${label}`"
      >
        <template #search="{ attributes, events }">
          <input
            class="vs__search"
            :required="required && !item"
            v-bind="attributes"
            v-on="events"
            @input="onChange(attributes.value)"
          />
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center" v-html="option.value"></div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center" v-html="option.value"></div>
        </template>
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            <b>Nada encontrado</b><br />
            <b>{{ search }}</b>
          </template>

          <em style="opacity: 0.5" v-if="array.length == 0 && search == ''">
            Digite o que deseja buscar.
          </em>
        </template>
        <template #spinner="{ isLoading }">
          <div
            v-if="isLoading"
            style="border-left-color: rgba(88, 151, 251, 0.71)"
            class="vs__spinner"
          ></div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputAutoComplete",
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    grid: {
      type: [Number],
      default: 2,
    },
    label: {
      type: [String],
      default: "",
    },
    placeholder: {
      type: [String],
      default: "",
    },
    ajuda: {
      type: [String],
      default: "",
    },
    required: {
      type: [Boolean],
      default: false,
    },
    disabled: {
      type: [Boolean],
      default: false,
    },
    uppercase: {
      type: [Boolean],
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    rota: {
      type: [String, Number],
      default: "json/cid.json",
    },
  },
  data() {
    return {
      isLoading: false,
      array: [],
      item: null,
    };
  },
  watch: {
    value(n, o) {
      this.item = n;
      this.onChange(n);
    },
  },
  mounted() {
    if (this.value) {
      this.isLoading = true;
      this.onChange(this.value);
    }
  },
  methods: {
    onChange(search) {
      if (search != null && search.length > 2) {
        this.isLoading = true;

        axios.get(window.urlbase + this.rota).then((response) => {
          this.array = response.data.filter((item) => {
            return (
              item.id.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
              item.value.toLowerCase().indexOf(search.toLowerCase()) > -1
            );
          });
          this.isLoading = false;
        });
      } else {
        // Let's search our flat array
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>
